import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const FridgeWPadding = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M9.333 14.667c0 .366-.3.666-.666.666A.669.669 0 018 14.667v-3.334H6V20h12v-8.667H9.333v3.334zM16.667 4H7.333C6.597 4 6 4.597 6 5.333V10h2V6.667C8 6.3 8.3 6 8.667 6c.366 0 .666.3.666.667V10H18V5.333C18 4.597 17.403 4 16.667 4z"
        id="prefix__a-fridgewpadding"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-fridgewpadding" fill="#fff">
        <use xlinkHref="#prefix__a-fridgewpadding" />
      </mask>
      <use
        fill="#FFF"
        fillRule="nonzero"
        xlinkHref="#prefix__a-fridgewpadding"
      />
      <g
        mask="url(#prefix__b-fridgewpadding)"
        fill={props.color || theme.palette.grey800}
      >
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
